module.exports = __webpack_public_path__ + "front/img/b26_3.b452fdf1.jpg";